(function () {
  var overlay = document.querySelector('[data-cart-overlay]');
  var drawer = document.querySelector('[data-cart-drawer]');
  var body = document.querySelector('[data-cart-body]');
  var footer = document.querySelector('[data-cart-footer]');
  var subtotalEl = document.querySelector('[data-cart-subtotal]');
  var countEls = document.querySelectorAll('[data-cart-count]');

  if (!drawer) return;

  function openCart() {
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) {
        closeCart();
      } else {
        renderCart();
        openCart();
      }
    });
  });
  overlay.addEventListener('click', closeCart);

  var currencyCode = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';

  function money(cents) {
    try {
      return (cents / 100).toLocaleString('en-IN', {
        style: 'currency',
        currency: currencyCode,
        maximumFractionDigits: 0,
      });
    } catch (e) {
      return currencyCode + ' ' + (cents / 100).toLocaleString('en-IN');
    }
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (res) { return res.json(); });
  }

  function renderCart() {
    fetchCart().then(updateCartUI);
  }

  function updateCartUI(cart) {
    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="rutam-cart-empty">Your bag is empty.</p>';
      if (footer) footer.style.display = 'none';
      return;
    }

    if (footer) footer.style.display = '';
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    body.innerHTML = cart.items
      .map(function (item) {
        var img = item.image
          ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '">'
          : '';
        return (
          '<div class="rutam-cart-line" data-line-key="' + item.key + '">' +
            '<div class="rutam-cart-line__media">' + img + '</div>' +
            '<div class="rutam-cart-line__info">' +
              '<div>' +
                '<div class="rutam-cart-line__title">' + escapeHtml(item.product_title) + '</div>' +
                '<div class="rutam-cart-line__price">' + money(item.final_price) + '</div>' +
              '</div>' +
              '<div class="rutam-cart-line__controls">' +
                '<div class="rutam-qty">' +
                  '<button type="button" data-qty-decrease aria-label="Decrease quantity">&minus;</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-qty-increase aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<button type="button" class="rutam-cart-line__remove" data-line-remove>Remove</button>' +
              '</div>' +
            '</div>' +
          '</div>'
        );
      })
      .join('');
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (res) { return res.json(); })
      .then(updateCartUI);
  }

  body.addEventListener('click', function (e) {
    var line = e.target.closest('[data-line-key]');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    var qtyEl = line.querySelector('.rutam-qty span');
    var qty = parseInt(qtyEl.textContent, 10);

    if (e.target.matches('[data-qty-increase]')) {
      changeLine(key, qty + 1);
    } else if (e.target.matches('[data-qty-decrease]')) {
      changeLine(key, Math.max(0, qty - 1));
    } else if (e.target.matches('[data-line-remove]')) {
      changeLine(key, 0);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    var formData = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (res) { return res.json(); })
      .then(function () {
        renderCart();
        openCart();
      })
      .catch(function (err) { console.error(err); })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  });

  var mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function () {
      mobileMenu.classList.toggle('is-open');
    });
  }

  document.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.parentElement.classList.toggle('is-open');
    });
  });

  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-carousel-slide]'));
    var prevBtn = carousel.querySelector('[data-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-carousel-next]');
    var dotsWrap = carousel.querySelector('[data-carousel-dots]');
    if (!track || slides.length === 0) return;

    var dots = slides.map(function (slide, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'rutam-carousel__dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', function () {
        slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
      if (dotsWrap) dotsWrap.appendChild(dot);
      return dot;
    });
    if (dots[0]) dots[0].classList.add('is-active');

    function scrollByOne(direction) {
      var gap = 20;
      var amount = (slides[0].getBoundingClientRect().width + gap) * direction;
      track.scrollBy({ left: amount, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByOne(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByOne(1); });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var idx = slides.indexOf(entry.target);
            if (idx === -1 || !entry.isIntersecting) return;
            dots.forEach(function (d) { d.classList.remove('is-active'); });
            if (dots[idx]) dots[idx].classList.add('is-active');
          });
        },
        { root: track, threshold: 0.6 }
      );
      slides.forEach(function (slide) { observer.observe(slide); });
    }
  });

  document.addEventListener('click', function (e) {
    var buyBtn = e.target.closest('[data-buy-now]');
    if (!buyBtn) return;
    var form = buyBtn.closest('form[data-product-form]');
    if (!form) return;
    buyBtn.disabled = true;
    var formData = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (res) { return res.json(); })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        console.error(err);
        buyBtn.disabled = false;
      });
  });

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variantsScript = form.querySelector('[data-product-variants]');
    if (!variantsScript) return;
    var variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var addBtn = form.querySelector('[type="submit"]');
    var buyBtn = form.querySelector('[data-buy-now]');
    var gallery = document.querySelector('[data-gallery]');
    var images = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-image-alt]')) : [];

    function selectedOptions() {
      var opts = [];
      form.querySelectorAll('[data-swatch].is-selected').forEach(function (btn) {
        opts[parseInt(btn.getAttribute('data-option-position'), 10) - 1] = btn.getAttribute('data-value');
      });
      form.querySelectorAll('select[data-option-position]').forEach(function (select) {
        opts[parseInt(select.getAttribute('data-option-position'), 10) - 1] = select.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (val, i) { return val == null || v.options[i] === val; });
      });
    }

    function filterGallery(colorValue) {
      if (!images.length) return;
      var matches = images.filter(function (img) {
        var alt = img.getAttribute('data-image-alt').toLowerCase();
        return alt === colorValue.toLowerCase() || alt === 'dimensions';
      });
      var toShow = matches.length ? matches : images;
      images.forEach(function (img) {
        img.style.display = toShow.indexOf(img) === -1 ? 'none' : '';
      });
    }

    function applyVariant() {
      var opts = selectedOptions();
      var variant = findVariant(opts);
      if (!variant) return;

      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        priceEl.textContent = variant.price > 0 ? money(variant.price) : 'Price on request';
      }
      var available = variant.available;
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'Add to Bag' : 'Sold Out';
      }
      if (buyBtn) buyBtn.style.display = available ? '' : 'none';
    }

    form.querySelectorAll('[data-swatch]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.rutam-swatch-field');
        group.querySelectorAll('[data-swatch]').forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
        var label = group.querySelector('[data-swatch-selected]');
        if (label) label.textContent = btn.getAttribute('data-value');
        filterGallery(btn.getAttribute('data-value'));
        applyVariant();
      });
    });

    form.querySelectorAll('select[data-option-position]').forEach(function (select) {
      select.addEventListener('change', applyVariant);
    });

    var initialSwatch = form.querySelector('[data-swatch].is-selected');
    if (initialSwatch) filterGallery(initialSwatch.getAttribute('data-value'));
  });

  var pressGrid = document.querySelector('[data-press-grid]');
  if (pressGrid) {
    document.querySelectorAll('[data-press-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('[data-press-filter]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var cat = btn.getAttribute('data-press-filter');
        pressGrid.querySelectorAll('[data-press-item]').forEach(function (item) {
          var show = cat === 'all' || item.getAttribute('data-category') === cat;
          item.style.display = show ? '' : 'none';
        });
      });
    });

    var pressModal = document.querySelector('[data-press-modal]');
    var pressModalBody = document.querySelector('[data-press-modal-body]');

    function closePressModal() {
      pressModal.classList.remove('is-open');
      pressModal.setAttribute('aria-hidden', 'true');
      pressModalBody.innerHTML = '';
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-press-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-embed-url');
        var sourceUrl = btn.getAttribute('data-source-url') || url;
        var title = btn.getAttribute('data-title') || '';
        var outlet = btn.getAttribute('data-outlet') || '';
        pressModalBody.innerHTML =
          '<h3>' + title + '</h3>' +
          '<div class="rutam-press-modal__outlet">' + outlet + '</div>' +
          '<div class="rutam-press-modal__frame-wrap"><iframe src="' + url + '" loading="lazy" title="' + title + '"></iframe></div>' +
          '<a href="' + sourceUrl + '" target="_blank" rel="noopener" class="rutam-link-arrow">Open full scan &#8599;</a>';
        pressModal.classList.add('is-open');
        pressModal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });

    document.querySelectorAll('[data-press-modal-close]').forEach(function (el) {
      el.addEventListener('click', closePressModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && pressModal.classList.contains('is-open')) closePressModal();
    });

    document.querySelectorAll('[data-yt-play]').forEach(function (el) {
      el.addEventListener('click', function () {
        var id = el.getAttribute('data-yt-id');
        el.innerHTML =
          '<iframe src="https://www.youtube.com/embed/' + id + '?autoplay=1" ' +
          'title="YouTube video" frameborder="0" ' +
          'allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" ' +
          'allowfullscreen></iframe>';
      });
    });
  }

  var shopForm = document.querySelector('[data-shop-form]');
  if (shopForm) {
    var filters = document.querySelector('[data-shop-filters]');
    var overlay = document.querySelector('.rutam-shop-filters-overlay');
    var openBtn = document.querySelector('[data-shop-filter-toggle]');

    function openFilters() {
      filters.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeFilters() {
      filters.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (openBtn) openBtn.addEventListener('click', openFilters);
    document.querySelectorAll('[data-shop-filter-close]').forEach(function (el) {
      el.addEventListener('click', closeFilters);
    });

    var applyBtn = document.querySelector('[data-shop-filter-apply]');
    if (applyBtn) applyBtn.addEventListener('click', closeFilters);

    var grid = document.querySelector('[data-shop-grid]');
    if (grid) {
      var products = Array.prototype.slice.call(grid.querySelectorAll('[data-shop-product]'));
      var filterInputs = Array.prototype.slice.call(document.querySelectorAll('[data-shop-filter-input]'));
      var countEl = document.querySelector('[data-shop-filter-count]');
      var chipsWrap = document.querySelector('[data-shop-chips]');
      var emptyState = document.querySelector('[data-shop-empty]');
      var clearAllBtn = document.querySelector('[data-shop-filter-clear]');

      function applyProductFilters() {
        var checked = filterInputs.filter(function (i) { return i.checked; });
        var collectionVals = checked.filter(function (i) { return i.getAttribute('data-filter-type') === 'collection'; }).map(function (i) { return i.value; });
        var typeVals = checked.filter(function (i) { return i.getAttribute('data-filter-type') === 'table-type'; }).map(function (i) { return i.value; });

        var visibleCount = 0;
        products.forEach(function (item) {
          var itemCollections = (item.getAttribute('data-collections') || '').split(',').filter(Boolean);
          var itemType = item.getAttribute('data-table-type') || '';
          var collMatch = collectionVals.length === 0 || collectionVals.some(function (v) { return itemCollections.indexOf(v) !== -1; });
          var typeMatch = typeVals.length === 0 || typeVals.indexOf(itemType) !== -1;
          var show = collMatch && typeMatch;
          item.style.display = show ? '' : 'none';
          if (show) visibleCount++;
        });

        if (countEl) {
          countEl.textContent = checked.length;
          countEl.style.display = checked.length > 0 ? '' : 'none';
        }

        if (chipsWrap) {
          chipsWrap.innerHTML = '';
          checked.forEach(function (i) {
            var labelText = i.closest('label').querySelector('span').textContent.replace(/\s*\(\d+\)\s*$/, '').trim();
            var chip = document.createElement('button');
            chip.type = 'button';
            chip.className = 'rutam-shop-chip';
            chip.innerHTML = labelText + ' <span>&times;</span>';
            chip.addEventListener('click', function () {
              i.checked = false;
              applyProductFilters();
            });
            chipsWrap.appendChild(chip);
          });
          chipsWrap.style.display = checked.length > 0 ? 'flex' : 'none';
        }

        if (clearAllBtn) clearAllBtn.style.display = checked.length > 0 ? '' : 'none';
        if (emptyState) emptyState.style.display = visibleCount === 0 ? '' : 'none';
      }

      filterInputs.forEach(function (i) { i.addEventListener('change', applyProductFilters); });
      if (clearAllBtn) {
        clearAllBtn.addEventListener('click', function () {
          filterInputs.forEach(function (i) { i.checked = false; });
          applyProductFilters();
        });
      }
    }
  }
})();
